import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AdminSidebar } from './Dashboard';
import api from '../../services/api';

export default function AdminVeiculos() {
  const [veiculos, setVeiculos] = useState([]);
  const carregar = () => api.get('/admin/veiculos').then(({ data }) => setVeiculos(data)).catch(() => {});
  useEffect(() => { carregar(); }, []);

  const toggle = async (id, campo, val) => { await api.patch(`/admin/veiculos/${id}`, { [campo]: val }); carregar(); };
  const excluir = async (id) => { if (window.confirm('Excluir este veículo?')) { await api.delete(`/admin/veiculos/${id}`); carregar(); } };

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1 className="admin-title">Veículos</h1>
          <Link to="/admin/veiculos/novo" className="btn btn-primary btn-sm">+ Novo veículo</Link>
        </div>

        <table className="tabela">
          <thead><tr><th>Veículo</th><th>Ano</th><th>Preço</th><th>Status</th><th>Publicado</th><th>Destaque</th><th>Ações</th></tr></thead>
          <tbody>
            {veiculos.map(v => (
              <tr key={v.id}>
                <td>
                  <div style={{ fontWeight:700, fontFamily:"'Playfair Display',serif" }}>{v.marca} {v.modelo}</div>
                  <div style={{ fontSize:11, color:'var(--ink-muted)' }}>{v.versao}</div>
                </td>
                <td style={{ fontWeight:700 }}>{v.ano}</td>
                <td style={{ fontWeight:900, color:'var(--rust)' }}>{v.preco ? `R$ ${Number(v.preco).toLocaleString('pt-BR')}` : '—'}</td>
                <td>
                  <select
                    value={v.status}
                    onChange={e => toggle(v.id, 'status', e.target.value)}
                    style={{ padding:'5px 10px', border:'1px solid var(--border)', borderRadius:'var(--r-sm)', fontSize:12, background:'#fff' }}>
                    {['disponivel','reservado','vendido','em_analise','inativo'].map(s => <option key={s} value={s}>{s.replace('_',' ')}</option>)}
                  </select>
                </td>
                <td style={{ textAlign:'center' }}>
                  <input type="checkbox" checked={!!v.publicado} onChange={e => toggle(v.id,'publicado', e.target.checked?1:0)} style={{ cursor:'pointer', accentColor:'var(--rust)' }} />
                </td>
                <td style={{ textAlign:'center' }}>
                  <input type="checkbox" checked={!!v.destaque} onChange={e => toggle(v.id,'destaque', e.target.checked?1:0)} style={{ cursor:'pointer', accentColor:'var(--rust)' }} />
                </td>
                <td style={{ display:'flex', gap:8 }}>
                  <Link to={`/admin/veiculos/${v.id}`} className="btn btn-outline btn-sm">Editar</Link>
                  <button className="btn btn-danger btn-sm" onClick={() => excluir(v.id)}>✗</button>
                </td>
              </tr>
            ))}
            {veiculos.length === 0 && <tr><td colSpan={7} style={{ textAlign:'center', color:'var(--ink-muted)', padding:36 }}>Nenhum veículo cadastrado.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
